import * as React from 'react';
// import logo from './logo.svg';
// import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { ThemeProvider } from '@mui/material/styles';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
// or
// import { MenuItem } from '@mui/material';
import AdbIcon from '@mui/icons-material/Adb';
import Alert from '@mui/material/Alert';

import { createRoot } from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Routes,
  Route,
  Link as RouteLink,
  useNavigate,
  useLocation,
  Navigate,
  Outlet,
  redirect,
  useHref 
} from "react-router-dom";

import theme from './theme';
import {AuthProvider, AuthContext, useAuth} from './context/AuthContext'
import {PrAvProvider, PrAvContext, usePrAvcontext} from './context/PrAVContext'
import {PrFissesProvider, PrFissesContext, usePrFissescontext} from './context/PrFissesContext'

import Sidelogin from './pages/Sidelogin';
import MotoPage from './pages/MotoPage';
import PartsDashboard from './pages/PartsDashboard'
import MotoDashboard from './pages/MotoDashboard';
import AfsDashboard from './pages/AfsDashboard';

// !!!!! import  Grid2  from '@mui/material/Unstable_Grid2';
import {default as Grid2} from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

// import config from './config/'; 

import {IMotdRow,IMotdResponse} from './pages/PageInterfaces'

import UnstyledButtonCustom from './pages/components/UnstyledButtonCustom'
import KsrgrButton from './pages/components/KsrgrButton'

import {returnBasenameUrl} from './utils'

type pageType = {
  menu: string;
  title: string;
  navto: string;
  routepath: string;
}

const MENU_PAGE_MOTO='Motocycles';
const MENU_TITLE_MOTO="μοτο";
const MENU_NAVTO_MOTO="/moto"
const MENU_ROUTEP_MOTO="moto"

const MENU_PAGE_PARTS='Parts';
const MENU_TITLE_PARTS="ανταλλακτικα";
const MENU_NAVTO_PARTS="/parts";
const MENU_ROUTEP_PARTS="parts"

const MENU_PAGE_AFTERSALES='Aftersales';
const MENU_TITLE_AFTERSALES="After Sales";
const MENU_NAVTO_AFTERSALES="/as";
const MENU_ROUTEP_AFTERSALES="as"

const MENU_PAGE_NEWS='News';
const MENU_TITLE_NEWS="Νέα";
const MENU_NAVTO_NEWS="/news";
const MENU_ROUTEP_NEWS="news"

const MENU_PAGE_TEST='Tests';
const MENU_TITLE_TEST="Tests";
const MENU_NAVTO_TEST="/tests";
const MENU_ROUTEP_TEST="tests"


// const pages = ['MotoCycles', 'Parts', 'AfterSales', 'News'];
// const pages:pageType[] = [{menu:'Parts', title:"ανταλλακτικα"},  {menu:'News', title: 'news'}];
const pages:pageType[] = [
  {menu:MENU_PAGE_PARTS, title:MENU_TITLE_PARTS, navto:MENU_NAVTO_PARTS, routepath:MENU_ROUTEP_PARTS},
  {menu:MENU_PAGE_AFTERSALES, title:MENU_TITLE_AFTERSALES, navto:MENU_NAVTO_AFTERSALES, routepath:MENU_ROUTEP_AFTERSALES}
];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];


function App() {
  
  const basename = returnBasenameUrl();
  console.log('=JS app=, App basename',basename)
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
      <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  );
}

function AppRoutes(){
  let location = useLocation();
  let auth = useAuth();
  console.log("=JS app=, AppRoutes location=", location)
  // console.log("AppRoutes: auth.userData=", auth.userData )
  if( auth.userData === undefined || auth.userData === null ||
    auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
    auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false)
 {
   return( <Sidelogin /> )
 }
 else
 {
  return(
    <Routes>
        <Route path="/" element={<Layout />} errorElement={<NoMatch />} >
          <Route index element={<RequireAuth><Home /></RequireAuth>} />
          <Route path={MENU_ROUTEP_MOTO} element={<RequireMotoAuth><MotoDashboard /></RequireMotoAuth>} />
          <Route path={MENU_ROUTEP_PARTS} element={<RequirePartsAuth><PrAvProvider><PrFissesProvider><PartsDashboard /></PrFissesProvider></PrAvProvider></RequirePartsAuth>} />
          {/* <Route path="as" element={<RequireASAuth><AfsDashboard /></RequireASAuth>} /> */}
          <Route path={MENU_ROUTEP_AFTERSALES} element={<RequirePartsAuth><PrFissesProvider><AfsDashboard /></PrFissesProvider></RequirePartsAuth>} />
          <Route path={MENU_ROUTEP_NEWS} element={<NewsPage />} />
          <Route path={MENU_ROUTEP_TEST} element={<TestPage />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
        <Route path="*" element={<NoMatch />} />
      </Routes>
  )
 }
}

function Layout() {
  return (
    <>
      <CssBaseline />
      <ResponsiveAppBar />
      <Outlet />
    </>
  )
}

function ResponsiveAppBar() {
  //const basename = useHref('/');
  const basename = returnBasenameUrl();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  let location = useLocation();
  let navigate = useNavigate();
  let auth = useAuth();
  const disMenuOption = (page:pageType) => {
    if(page.menu===MENU_PAGE_MOTO) {
      return auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
        auth.userData.motoaccesslevel ===undefined || auth.userData.motoaccesslevel===null ||auth.userData.motoaccesslevel<1 ;
    }
    else if(page.menu===MENU_PAGE_PARTS) {
      return auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
        auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null ||auth.userData.partsaccesslevel<1 ;
    }
    else if(page.menu===MENU_PAGE_AFTERSALES) {
      return auth.userData === undefined || auth.userData === null ||
        auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
        auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
        auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null ||auth.userData.partsaccesslevel<1 ;
      // return auth.userData === undefined || auth.userData === null ||
      //   auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
      //   auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
      //   auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null ||auth.userData.aftersaccesslevel<1 ;
    }
    else return false
  }
  

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
    // console.log('clicked navmenu ..?')
    //
  };

  const handleCloseNavItemMenu = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, page:pageType) => {
    setAnchorElNav(null);
    console.log('=JS app=, handleCloseNavItemMenu clicked navItem menu', page)
    if(page.menu===MENU_PAGE_MOTO) {
      // console.log('clicked navItem menu', page, "navigating to /moto")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/moto") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }
    else if(page.menu===MENU_PAGE_PARTS) {
      // console.log('clicked navButton menu', page, "navigating to /parts")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/parts") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }
    else if(page.menu===MENU_PAGE_AFTERSALES) {
      navigate("/as") 
    }
    else if(page.menu===MENU_PAGE_NEWS) {
      // console.log('clicked navButton menu', page, "navigating to /news")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/news") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }
  };
  const handleCloseNavBtnMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, page:pageType) => {
    setAnchorElNav(null);
    console.log('=JS app=, handleCloseNavItemMenu clicked navButton menu', page)
    if(page.menu===MENU_PAGE_MOTO) {
      // console.log('clicked navButton menu', page, "navigating to /moto")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/moto") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }
    else if(page.menu===MENU_PAGE_PARTS) {
      // console.log('clicked navButton menu', page, "navigating to /parts")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/parts") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }
    else if(page.menu===MENU_PAGE_AFTERSALES) {
      navigate("/as") 
    }
    else if(page.menu===MENU_PAGE_NEWS) {
      // console.log('clicked navButton menu', page, "navigating to /news")
      // return <Navigate to={`${process.env.REACT_APP_MAIN_ROOT}/moto`} state={{ from: location }} replace />;
      navigate("/news") // `${process.env.REACT_APP_MAIN_ROOT}/moto`
    }

  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  // (e: React.MouseEvent<HTMLButtonElement>, value?: boolean)
  const handleNavMenuSelection = (e: React.MouseEvent<HTMLLIElement, MouseEvent>, page:pageType)=>{
    
  }

  return (
    <AppBar id="appbar0" position="static">
      <Container id="container0" maxWidth="xl">
        <Toolbar id="toolbar0" disableGutters>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
          <Box id="boxlogoimg0" component="img" sx={{ height: 64, }} alt="KSR GR logo."
            src={`${basename}images/ksr_logo.svg`}  
          />
          <Typography variant="h6" noWrap component="a" href={`${basename}`}
            sx={{mr: 2, display: { xs: 'none', md: 'flex' }, fontFamily: 'monospace',
              fontWeight: 700, letterSpacing: '.1rem', color: 'inherit', textDecoration: 'none',
            }}
          >
          Hellas
          </Typography>

          {/* when collapsed */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton size="large" aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true"
              onClick={handleOpenNavMenu} color="inherit" >
              <MenuIcon />
            </IconButton>
            <Menu id="menu-appbar" anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left', }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{display: { xs: 'block', md: 'none' },}}
            >
              {pages.map((page) => (
                <MenuItem key={page.menu} onClick={ (e)=>{handleCloseNavItemMenu(e,page)} }
                  disabled = {disMenuOption(page)} >
                  <Typography textAlign="center">{'- '}{page.title}{' -'}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* when displayed , large screen */}
          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <Typography variant="h5" noWrap component="a" href={`${basename}`}
            sx={{mr: 2, display: { xs: 'flex', md: 'none' }, flexGrow: 1,
              fontFamily: 'monospace', fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', textDecoration: 'none',}}
          >
          Hellas
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button key={page.menu} disabled = {disMenuOption(page)} onClick={(e)=>{handleCloseNavBtnMenu(e,page)}}
                sx={[{my: 2}, {display: 'block'}, {color: 'white' }, ]} >
                {page.title}
              </Button>
            ))}
          </Box>

          {/*
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          */}
        </Toolbar>
      </Container>
    </AppBar>
  );
}

function RequireAuth({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();
  // console.log("=JS app=, RequireAuth, location=", location)
  // console.log("=JS app=, RequireAuth: auth.userData=", auth.userData )
  if( auth.userData === undefined || auth.userData === null ||
    auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
    auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false  
  ){
      console.log("=JS app=, RequireAuth: user auth checks failed")
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // else ...
  // console.log(" RequireAuth: user auth checks succeded")
  return children ;
}

function RequireMotoAuth({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();
  if( auth.userData === undefined || auth.userData === null ||
    auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
    auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
    auth.userData.motoaccesslevel===undefined || auth.userData.motoaccesslevel===null ||auth.userData.motoaccesslevel<1 ){
      console.log("=JS app=, RequireMOTO Auth: user auth checks failed")
      return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children ;
}
function RequirePartsAuth({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();
  if( auth.userData === undefined || auth.userData === null ||
    auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
    auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
    auth.userData.partsaccesslevel===undefined || auth.userData.partsaccesslevel===null ||auth.userData.partsaccesslevel<1 ){
      console.log("=JS app=, RequirePARTSAuth: user auth checks failed")
      return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children ;
}
function RequireASAuth({ children }: { children: JSX.Element }) {
  let auth = useAuth();
  let location = useLocation();
  if( auth.userData === undefined || auth.userData === null ||
    auth.userData.userid===null || auth.userData.userid===undefined || auth.userData.userid<=0 || 
    auth.userData.success===undefined || auth.userData.success===null ||auth.userData.success===false ||
    auth.userData.aftersaccesslevel===undefined || auth.userData.aftersaccesslevel===null ||auth.userData.aftersaccesslevel<1 ){
      console.log("=JS app=, RequireASAuth: user auth checks failed")
      return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children ;
}
/* ksrgrb2b_moto_userinfo:"{"success":true,"userid":"305","username":"tstylianop","token":"9J8p9JL2OrXpJsfuTa1eUIKsC4L4M692M55dLr8bDqHrLoKtHMnIIK5uSaqbDZ1uTqqbDKLbGqb4P451UKXqLs95S5abDKHvLL4bDqGbDqHLLN9nPLH1SM52GN1rHN9OSqqbDqLbTLTsJ75CIK5qLKebDqHLM40bDZ1sJtCbDKDYGYKtGoKsC6KbDKGbDKLPHLL7M710LqnoGqebDZ1b9JL3Nr55LMjD9JOmGLLiK4H6U4P0OoKtH6LLJqbIG450Oq16I5LLMbLLHMSbDKCbDZ16GNXNLr59TLfK9JL3K4HNR652RabmM5frHKjo9JT4PLLoGG","error":"","refid":"257","module":"13","modulename":"Πελάτης","userinfo":{"WEBUSERNAME":"tstylianop","WEBUSEREMAIL":"tstylianop2@gmail.com","LCOMPANY":1001,"LBRANCH":1000,"bus":[{"WEBSERVICE":1010,"bu":10,"buname":"Motocycles","trdr":257,"trdbame":"STYLIANOP","trdbranch":0,"trdbrnname":"","trdafm":"044224042","trdemail":"tstylianop@gmail.com","whs":"10,11","accesslevel":2},{"WEBSERVICE":1020,"bu":20,"buname":"MotoParts","trdr":257,"trdbame":"STYLIANOP","trdbranch":0,"trdbrnname":"","trdafm":"044224042","trdemail":"tstylianop@gmail.com","whs":"2","accesslevel":2}]},"motoaccesslevel":2,"partsaccesslevel":2,"aftersaccesslevel":0}"
userData={ 
  "success": true,
  "userid": "305",
  "username": "tstylianop",
  "token": "9J8p9JL2OrXpJsfuTa1eUIKsC4L4M692M55dLr8bDqHrLoKtHMnIIK5uSaqbDZ1uTqqbDKLbGqb4P451UKXqLs95S5abDKHvLL4bDqGbDqHLLN9nPLH1SM52GN1rHN9OSqqbDqLbTLTsJ75CIK5qLKebDqHLM40bDZ1sJtCbDKDYGYKtGoKsC6KbDKGbDKLPHLL7M710LqnoGqebDZ1b9JL3Nr55LMjD9JOmGLLiK4H6U4P0OoKtH6LLJqbIG450Oq16I5LLMbLLHMSbDKCbDZ16GNXNLr59TLfK9JL3K4HNR652RabmM5frHKjo9JT4PLLoGG",
  "error": "",
  "refid": "257",
  "module": "13",
  "modulename": "Πελάτης",
  "userinfo": {
    "WEBUSERNAME": "tstylianop",
    "WEBUSEREMAIL": "tstylianop2@gmail.com",
    "LCOMPANY": 1001,
    "LBRANCH": 1000,
    "bus": [
      {
        "WEBSERVICE": 1010,
        "bu": 10,
        "buname": "Motocycles",
        "trdr": 257,
        "trdbame": "STYLIANOP",
        "trdbranch": 0,
        "trdbrnname": "",
        "trdafm": "044224042",
        "trdemail": "tstylianop@gmail.com",
        "whs": "10,11",
        "accesslevel": 2
      },
      {
        "WEBSERVICE": 1020,
        "bu": 20,
        "buname": "MotoParts",
        "trdr": 257,
        "trdbame": "STYLIANOP",
        "trdbranch": 0,
        "trdbrnname": "",
        "trdafm": "044224042",
        "trdemail": "tstylianop@gmail.com",
        "whs": "2",
        "accesslevel": 2
      }
    ]
  },
  "motoaccesslevel": 2,
  "partsaccesslevel": 2,
  "aftersaccesslevel": 0
}
*/
function TestPage() {
  return(
    <>
    <p> <RouteLink to="/">Go to the home page</RouteLink></p>
    </>
  )

}

// function ASPage(){
//   return(<>AfterSales Page<p>
//     <RouteLink to="/">Go to the home page</RouteLink>
//   </p></>)
// }

// function btnClick(){
//   alert('btn clicked')
// }

function StylenComponenets()
{
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
 // const basename = useHref('/'); 
  const basename = returnBasenameUrl();
return(<>     
 <Alert severity="success">action was successful.</Alert>
<Alert severity="error">action was error.</Alert>
<Alert severity="warning">action was warning.</Alert>
<Alert severity="info">action was info.</Alert>
<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel1-content"
    id="panel1-header"
  >
    Ενότητα 1.
  </AccordionSummary>
  <AccordionDetails>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    malesuada lacus ex, sit amet blandit leo lobortis eget.
  </AccordionDetails>
</Accordion>
<Accordion>
  <AccordionSummary
    expandIcon={<ExpandMoreIcon />}
    aria-controls="panel2-content"
    id="panel2-header"
  >
    Ενότητα 2.
  </AccordionSummary>
  <AccordionDetails>
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    malesuada lacus ex, sit amet blandit leo lobortis eget.
  </AccordionDetails>
</Accordion>


<AppBar position="static">
  <Container maxWidth="xl">
    <Toolbar disableGutters>
      <Box component="img" sx={{ height: 64, }}
         alt="KSR Hellas" src={`${basename}images/ksr_logo.svg`} /> {/* ${process.env.REACT_APP_MAIN_ROOT} */}
          <Typography variant="h6" noWrap component="a" href={`${basename}`}
            sx={{ mr: 2, display: { xs: 'none', md: 'flex' }, fontFamily: 'monospace', fontWeight: 700,
             letterSpacing: '.1rem',
             color: 'inherit',
            textDecoration: 'none', }} >
          Hellas
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              
                <MenuItem key={'menupage1'} 
                  disabled = {true} >
                  <Typography textAlign="center" sx = {{ color: 'yellow' }}>{'contuct us...'}</Typography>
                </MenuItem>
              
            </Menu>
          </Box>
          {/* <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} /> */}
          <Typography
            variant="h5"
            noWrap
            component="a"
            href={`${basename}`}
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
          Hellas
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              <Button
                key={'btnpage1'}
                disabled={true}
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {'contuct us ...'}
              </Button>
          </Box>
        </Toolbar>
      </Container>
</AppBar>


</>)
}
function NewsPage(){
  return(
    <>
    <StylenComponenets />
    </>
  )
}
function Home(){
  let auth = useAuth();
  let basename=returnBasenameUrl()
  const [motds, setMotds] = React.useState<IMotdRow[] | null>( null )
  React.useEffect( () => {
    if(auth.userData.success!==true) return
    let token = auth.userData.token
    // console.log("=JS app=, Home auth.userData.token=",token)
    let usercode = auth.userData.username
    let postdata = {
        service: "getmodtd", 
        usercode: auth.userData.username,
        userid: auth.userData.userid,
        appid: process.env.REACT_APP_APPID,
        clientid: token,
    }
    let body =  JSON.stringify(postdata) // `{"service": "getmodtd", "usercode":"${usercode}", "userid": ${auth.userData.userid}, "appid": ${process.env.REACT_APP_APPID}, "clientid":"${token}"}`
    let url =`${basename}${process.env.REACT_APP_B2B_API_URL}`;
    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body 
    })
    .then((response) =>  {
        if (!response.ok) return {} 
        else return response.json()
      })
    .then((data:any) => {
        // console.log(" fetch motds then ... data=",data)
        const isSuccessMotdResponse = (data: any): data is IMotdResponse =>
        typeof data === 'object' && data !== null && data.hasOwnProperty('success') && typeof data.success === 'boolean' ;
        if (isSuccessMotdResponse(data) && data.success!==true)
        {
          console.log("=JS app=, Home, fetched motds data NOT Success MotdResponse")
          setMotds(  null )
        }
        else {
            // console.log("data.hasOwnProperty('motds')",data.hasOwnProperty('motds'),"typeof data.rows",typeof data.motds,"Array.isArray(data.motds)",Array.isArray(data.motds),"data.motds.length",data.motds.length)
            if(data.hasOwnProperty('motds') && typeof data.motds === 'object' && Array.isArray(data.motds) && data.motds.length>0){
                //const motosdata: IMotoBrand[] = data.rows
                let memolines:string[] = []
                let mods = data.motds as IMotdRow[]
                mods.forEach( (mod) => {
                  mod.memolines = mod.memo.split("&13;&10;")                  
                });
                setMotds( data.motds )
                // console.log(" fetched motds data Success rows Array set")
            }
            else {
              setMotds(  null )
              console.log("=JS app=, Home, fetched motds data NOT rows Array")
            }
        }                         
      })
},[])

  return(
    <Box sx={{ display: 'flex', flexDirection:'column' }} justifyContent={'center'} alignItems={'center'}>
     <div > 
      <Typography component="h1"  variant="h6" color="inherit" noWrap sx={{ flexGrow: 1 }} >
      Καλώς ήλθατε στο χώρο εργασίας (portal) της KSR Hellas
      </Typography>
      </div>
      <div>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            ΟΔΗΓΙΕΣ ΧΡΗΣΗΣ: Μην χρησιμοποιείτε την επιστροφή (back) του περιηγητή σας (internet browser) γιατί δεν υποστηρίζεται. 
            Περιηγήστε με τις επιλογές των μενού, των κουμπιών ή των συνδέσμων μέσα σε αυτή την σελίδα-εφαρμογή.
          </Typography>
      </div>
    {motds?.map( (elem) => {
      return (
        <Card sx={{ minWidth: 275, width:'90%' }} key={elem.motdid}>
        <CardContent>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Μήνυμα ημέρας {elem.trndate}
          </Typography>
          <Typography variant="h5" component="div">
          {elem.title}
          </Typography>
          {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
            adjective
            </Typography> */}
          {elem.memolines?.map( (line, index) => 
            <Typography variant="body2" key={`memloine${index}`}>
              {line}
            </Typography> )}
                      
        </CardContent>

      </Card>
      )
    })}

    </Box>
  )
}

function NoMatch() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <RouteLink to="/">Go to the home page</RouteLink>
      </p>
    </div>
  );
}

export default App;
